import createPersistedState from 'vuex-persistedstate'

// This is where we should migrate the stored data
function migration(parsed) {
  if (!parsed.emittedEvents) {
    parsed.emittedEvents = []
    if (parsed.linkedEventEmitted) parsed.emittedEvents.push('linked')
    if (parsed.blacklistEventEmitted) parsed.emittedEvents.push('blacklist')
  }

  if ('showDemoApp' in parsed) {
    parsed.showBackendDemoApp = parsed.showDemoApp
    delete parsed.showDemoApp
  }
  if (
    !Array.isArray(parsed.preferredMetrics) ||
    !parsed.preferredMetrics.every(obj => Array.isArray(obj.metrics))
  ) {
    parsed.preferredMetrics = []
  } else {
    const availableAggregations = ['avg', 'min', 'max']
    parsed.preferredMetrics.forEach(obj => {
      obj.metrics = obj.metrics.map(metric => {
        const aggregationType = metric.aggregationType.toLowerCase()
        return {
          name: metric.name,
          aggregationType: availableAggregations.includes(aggregationType)
            ? aggregationType
            : availableAggregations[0],
        }
      })
    })
  }
}

export default createPersistedState({
  storage: window.localStorage,
  getState(key, storage, value) {
    let parsed
    try {
      const value = storage.getItem(key)
      parsed = JSON.parse(value)
    } catch (err) {
      return
    }

    if (!parsed || typeof parsed !== 'object') return

    try {
      migration(parsed)
    } catch (e) {
      console.error('While parsing the persistent state:', e)
      return
    }
    return parsed
  },
  paths: ['theme', 'preferredMetrics', 'showBackendDemoApp', 'emittedEvents', 'locale'],
})
